// @flow

import React from "react";
import Media from "react-media";

import Sidebar from "./Sidebar";
import ContentWrapper from "./ContentWrapper";

// Common Components
import { Flex } from "@src/common";

class Assessment extends React.Component {
  componentDidMount() {
    window.onbeforeunload = e => {
      return "Changes you made will not be saved.";
    };
  }

  componentWillUnmount() {
    window.onbeforeunload = null;
  }

  render() {
    const content = (
      <Flex alignItems="flex-start">
        <Sidebar key="sidebar" />
        <ContentWrapper key="contentwrapper" />
      </Flex>
    );

    return (
      <Media query="(min-width: 1200px)">
        {matches =>
          (matches
            ? <div className="container">
                {content}
              </div>
            : <div className="container-fluid" style={{ padding: 0 }}>
                {content}
              </div>)}
      </Media>
    );
  }
}

export default Assessment;



// WEBPACK FOOTER //
// ./src/containers/Assessment/index.jsx